export const dashboardMixins = {
  data() {
    return {
      window: {
        width: 0
      }
    }
  },

  methods: {
    dashboardControlsVisible (dashboard) {
      if (typeof dashboard == 'undefined') {
        return false
      }

      var authorized = false
      var ownerId
      var locked

      if (dashboard.attributes) {
        ownerId = dashboard.attributes.owner_id
        locked = dashboard.attributes.locked
      } else {
        ownerId = dashboard.owner_id
        locked = dashboard.locked
      }

      if (!locked) {
        authorized = true
      } else if (this.currentUser.isAdmin) {
        authorized = true
      } else if (this.currentUser.id === ownerId ) {
        authorized = true
      }

      return authorized
    },

    getWindowWidth() {
      this.window.width = window.innerWidth;
    },

    mobileWidget(){
      this.window.width = window.innerWidth;
      if(this.window.width < 768) {
        this.$store.commit('setWidgetsSettingsVisibility', false)
      }
    }
  }
}
